import { Select as SuiSelect } from '@tempo-io/sui-select';

type OptionType = { value: string | number; label: string };

export type SelectProps = {
  menuItems?: OptionType[];
  placeholder?: string;
  value?: string | number | null;
  onChange?: (value: string | number | null) => void;
  isDisabled?: boolean;
};

export const Select = ({ menuItems, placeholder, value, onChange, isDisabled }: SelectProps) => {
  const selectedOption = menuItems?.find((opt) => opt.value === value) ?? null;

  return (
    <SuiSelect<OptionType>
      options={menuItems}
      value={selectedOption}
      onChange={(opt) => onChange?.(opt?.value ?? null)}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};
